__turbopack_context__.v({
  "cellWithTooltipLabel": "dealStatus-module-scss-module__-rLhaa__cellWithTooltipLabel",
  "column": "dealStatus-module-scss-module__-rLhaa__column",
  "label": "dealStatus-module-scss-module__-rLhaa__label",
  "link": "dealStatus-module-scss-module__-rLhaa__link",
  "nameCell": "dealStatus-module-scss-module__-rLhaa__nameCell",
  "sectorLabel": "dealStatus-module-scss-module__-rLhaa__sectorLabel",
  "statusCell": "dealStatus-module-scss-module__-rLhaa__statusCell",
  "statusIndicator": "dealStatus-module-scss-module__-rLhaa__statusIndicator",
  "statusLabel": "dealStatus-module-scss-module__-rLhaa__statusLabel",
  "statusLabelBorderAnnc": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderAnnc",
  "statusLabelBorderCncd": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderCncd",
  "statusLabelBorderFifteenG": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderFifteenG",
  "statusLabelBorderFild": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderFild",
  "statusLabelBorderGdnc": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderGdnc",
  "statusLabelBorderIpt": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderIpt",
  "statusLabelBorderLnch": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderLnch",
  "statusLabelBorderMndt": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderMndt",
  "statusLabelBorderPmkt": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderPmkt",
  "statusLabelBorderPrcd": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderPrcd",
  "statusLabelBorderPtpd": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderPtpd",
  "statusLabelBorderRumr": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderRumr",
  "statusLabelBorderSprd": "dealStatus-module-scss-module__-rLhaa__statusLabelBorderSprd",
  "tagsCellItem": "dealStatus-module-scss-module__-rLhaa__tagsCellItem",
  "tagsCellTooltipContent": "dealStatus-module-scss-module__-rLhaa__tagsCellTooltipContent",
  "tagsCellTooltipItem": "dealStatus-module-scss-module__-rLhaa__tagsCellTooltipItem",
  "tooltip": "dealStatus-module-scss-module__-rLhaa__tooltip",
});
